class SettingsBar {
  constructor() {
    this.showPopup();
  }
    
  showPopup() {
    $('body').on('click', '[data-settings-bar-layout]', (event) => {
      const $this = $(event.currentTarget);
      const id = $this.data('settings-bar-layout');
      const url = $this.data('settings-bar-video');
      if ($this.parent().hasClass('active')) {
        if (url !== '' || url !== undefined) {
          $('[data-settings-bar-popup-src-video]').attr('src', '');
        }
        $this.parent().removeClass('active');
        $(`#${id}`).removeClass('active-show');
        $('[data-settings-bar-layout-close]').removeClass('active-close');
      } else {
        if (url !== '' || url !== undefined) {
          $('[data-settings-bar-popup-src-video]').attr('src', `https://www.youtube.com/embed/${url}?rel=0&cc_load_policy=1`);
        }
        $('.settings-bar-item').removeClass('active');
        $this.parent().addClass('active');
        $('[data-settings-bar-content]').removeClass('active-show');
        $(`#${id}`).addClass('active-show');
        $('[data-settings-bar-layout-close]').addClass('active-close');
      }
    });
    $('body').on('click', '[data-settings-bar-layout-close]', () => {
      $('[data-settings-bar-popup-src-video]').attr('src', '');
      $('.settings-bar-item').removeClass('active');
      $('[data-settings-bar-content]').removeClass('active-show');
      $('[data-settings-bar-layout-close]').removeClass('active-close');
    });
  }
    
  
}

new SettingsBar();